import { render, staticRenderFns } from "./testingWizard.vue?vue&type=template&id=7b524812&scoped=true&"
import script from "./testingWizard.vue?vue&type=script&lang=js&"
export * from "./testingWizard.vue?vue&type=script&lang=js&"
import style0 from "./testingWizard.vue?vue&type=style&index=0&id=7b524812&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b524812",
  null
  
)

export default component.exports